module.exports = __webpack_public_path__ + "img/jiu.a6ea0661.png";